<template>
    <Card :class="cardClass">
        <CardHeader
            class="space-y-0 pb-2 flex flex-row items-center justify-between"
        >
            <CardTitle class="text-sm font-medium text-iron-600">
                {{ title }}
            </CardTitle>
            <div v-if="trendUp" class="text-green-500">
                <TrendingUp class="h-4 w-4" />
            </div>
            <div v-else-if="trendDown" class="text-red-500">
                <TrendingDown class="h-4 w-4" />
            </div>
        </CardHeader>
        <CardContent>
            <div :class="valueClass">
                {{ formattedValue }}
            </div>
            <p v-if="subtitle" class="text-xs text-iron-500 mt-1">
                {{ subtitle }}
            </p>
        </CardContent>
    </Card>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TrendingUp, TrendingDown } from "lucide-vue-next";

const props = withDefaults(
    defineProps<{
        title: string;
        value: string | number;
        subtitle?: string;
        variant?: "default" | "positive" | "negative";
        trendUp?: boolean;
        trendDown?: boolean;
    }>(),
    {
        variant: "default",
        trendUp: false,
        trendDown: false,
    },
);

const formattedValue = computed(() => {
    if (typeof props.value === "number") {
        return props.value.toLocaleString();
    }
    return props.value;
});

const cardClass = computed(() => {
    const base = "transition-colors";
    switch (props.variant) {
        case "positive":
            return `${base} border-l-4 border-l-green-500`;
        case "negative":
            return `${base} border-l-4 border-l-red-500`;
        default:
            return base;
    }
});

const valueClass = computed(() => {
    const base = "text-2xl font-bold";
    switch (props.variant) {
        case "positive":
            return `${base} text-green-600`;
        case "negative":
            return `${base} text-red-600`;
        default:
            return `${base} text-iron-900`;
    }
});
</script>
